import { ToolOrderInventory, User, UserProject } from '@bechtel/ht-types';
import React from 'react';

export interface ReturnToolProps {
  onCloseCallback?: () => void;
  toolOrderInventoryIds?: string[];
  user?: UserProject;
  toolRoomId?: string;
}
export interface ReturnToolContextProps {
  selectedCheckInToolList: ToolOrderInventory[] | null;
  dispatch: React.Dispatch<React.SetStateAction<{ type: actionType; payload: ToolOrderInventory[] | null }>>;
}

export interface ReturnToolOwnedItemProps {
  item: User;
  hideIcon;
}

export enum actionType {
  ADD = 'Add',
  ADDLL = 'AddAll',
  REMOVE = 'Remove',
  UPDATE_STATUS = 'Update_status',
  INCREMENT_QUANTITY = 'Increment_quantity',
  Decrement_QUANTITY = 'Decrement_quantity',
  RESET_ALL = 'Reset_All',
  ADD_COMMENT = 'Add_Comment',
}

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}
